import React from "react";
import { Building2, Handshake, Cog, BarChart3, ShieldCheck, Users } from "lucide-react";
import { ContentPage, Section, FeatureCard } from "../../components/ContentPage";

export default function DlaAgencji() {
  return (
    <ContentPage
      testid="page-dla-agencji"
      eyebrow="Współpraca B2B"
      title={<>Dla agencji <span className="text-coral">i managerów.</span></>}
      lead="Prowadzisz agencję lub zarządzasz twórczyniami? PMPOINT oferuje współpracę B2B, technologię, know-how i szkolenia, które pomagają skalować wyniki i zarabiać więcej."
      seo={{
        title: "Współpraca dla agencji i managerów | PMPOINT",
        description: "Współpraca B2B dla agencji i managerów w branży twórczyń 18+: technologia, automatyzacja, szkolenia i know-how do skalowania przychodów.",
        canonical: "https://pmpoint.pl/dla-agencji",
      }}
    >
      <Section title="Co zyskujesz">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <FeatureCard icon={Handshake} title="Partnerstwo B2B" text="Elastyczne modele współpracy dopasowane do skali Twojego biznesu." />
          <FeatureCard icon={Cog} title="Technologia i automatyzacja" text="Narzędzia, które odciążają zespół i zwiększają efektywność sprzedaży." />
          <FeatureCard icon={BarChart3} title="Analityka i wyniki" text="Dane w czasie rzeczywistym i optymalizacja pod realny przychód." />
          <FeatureCard icon={Users} title="Szkolenia zespołu" text="Podnosimy kompetencje Twoich chatterów i managerów." />
          <FeatureCard icon={ShieldCheck} title="Bezpieczeństwo" text="Umowy, poufność i zgodność z regulaminami platform." />
          <FeatureCard icon={Building2} title="Know-how" text="Dzielimy się sprawdzonymi procesami z branży." />
        </div>
      </Section>

      <Section>
        <div className="pm-card p-8 md:p-10">
          <h3 className="font-display font-semibold text-2xl text-white mb-3">Porozmawiajmy o współpracy</h3>
          <p className="text-white/70 max-w-[56ch] mb-6">
            Napisz do nas z dopiskiem „agencja" — przygotujemy ofertę dopasowaną do Twojej skali i celów.
          </p>
          <a
            href="/kontakt"
            className="inline-flex items-center h-12 px-6 rounded-lg bg-coral text-white font-bold hover:bg-coral-hover transition-colors"
            data-testid="agency-contact-btn"
          >
            Przejdź do kontaktu
          </a>
        </div>
      </Section>
    </ContentPage>
  );
}
